import halcyonFormCatalog from './halcyonFormCatalog.reducer';

const reducer = {
  halcyonFormCatalog,
};

export default reducer;
